import { gql } from '@apollo/client'

export const GET_AI_MENU = gql`
  query getAIMenu(
    $model: AiCreateArtworkModel = ANIME_DIFFUSION
    $pattern: AiCreateArtworkPattern
  ) {
    pictureGraph {
      aiCreateArtworkOptionMenu(param: { pattern: $pattern }) {
        defaultArtWorkList
        numCeiling
        # 大模型-二次元、通用等
        modelSupportOptions {
          desc
          model
          modelSupport {
            modelCode
            pattern
            recommendedCreativityDegree
          }
          name
          url
          tag
        }
        # 模型主题
        ddModelThemeOptions: modelThemeOptions(model: DISCO_DIFFUSION) {
          key
          name
          url
          isNew
          modelCode
          recommendedCreativityDegree
          supportLoRA
        }
        sdModelThemeOptions: modelThemeOptions(model: STABLE_DIFFUSION) {
          key
          name
          url
          isNew
          modelCode
          recommendedCreativityDegree
          supportLoRA
        }
        adModelThemeOptions: modelThemeOptions(model: ANIME_DIFFUSION) {
          key
          name
          url
          isNew
          modelCode
          recommendedCreativityDegree
          supportLoRA
        }
        # 新的风格选择-包含风格修饰、元素魔法、艺术家
        styleDecorationOptions(model: $model) {
          key
          name
          type
          category
        }
        # 角色同人
        characterOptions {
          key
          name
          type
          category
          isNew
        }
        # Lora模型
        modelFusionOptions {
          key
          name
          type
          category
          weight: recommendedWeight
          isNew
        }
        recommendedModelFusionOptions {
          key
          name
          type
          category
          weight: recommendedWeight
          isNew
        }
        ddSize: sizeSetOptions(model: DISCO_DIFFUSION) {
          name
          desc
          url
          resolutionList {
            length
            width
            price
            superType
          }
        }
        sdSize: sizeSetOptions(model: STABLE_DIFFUSION) {
          name
          desc
          url
          resolutionList {
            length
            width
            price
            superType
          }
        }
        # 一些参数的默认配置
        modelParam {
          cfg
          samplerIndex
          # steps
        }
        # 描述提示词选项
        promptTipsOptions(num: 2, model: $model) {
          name
        }
        # 模式（目前只有controlNet）下的模型选择
        patternModelOptions {
          desc
          model
          modelCode
          name
          recommendedCreativityDegree
          supportLoRA
        }
        inWhiteList
        samplerOptions(model: $model) {
          key: samplerIndex
          name: samplerModelName
        }
        controlPrefineOption {
          superType
          price
        }
      }
    }
  }
`
/** 用户权益卡 */
export const GET_AI_MEMBER_LIST = gql`
  query getAIMemberList(
    $statusList: [CardStatus] = [EFFECTIVE]
    $groupList: [AccountGroupTypeEnum]
  ) {
    accountModule {
      userMemberCardList(
        param: { statusList: $statusList, groupList: $groupList }
      ) {
        cardType
        name
        image
        price
        showPrice
        hold
        endTime
        holdCardInfo {
          num
          endTime
          rightType
        }
        cardRuleInfo
        cardRight {
          icon
          num
          name
          rightType
        }
      }
    }
  }
`

/** 模型主题 */
export const GET_AI_MODEL_THEME = gql`
  query getAIModelTheme($model: AiCreateArtworkModel!) {
    pictureGraph {
      aiCreateArtworkOptionMenu {
        modelThemeOptions(model: $model) {
          name
          url
          isNew
          modelCode
          recommendedCreativityDegree
          supportLoRA
        }
      }
    }
  }
`

/** 风格选择 */
export const GET_AI_STYLE_DECORATION = gql`
  query getAIstyleDecoration($model: AiCreateArtworkModel!) {
    pictureGraph {
      aiCreateArtworkOptionMenu {
        # 新的风格选择-包含风格修饰、元素魔法、艺术家
        styleDecorationOptions(model: $model) {
          key
          name
          type
          category
        }
      }
    }
  }
`

/** 所有模型支持的尺寸 */
export const GET_AI_SIZES = gql`
  query getAISizes {
    pictureGraph {
      aiCreateArtworkOptionMenu {
        size: sizeOptions {
          name
        }
      }
    }
  }
`

export const GET_AI_MODELCODE_DEFAULT_OPTIONS = gql`
  query getAIModelcodeDefaultOptions($modelCode: Int) {
    pictureGraph {
      aiCreateArtworkOptionMenu {
        modelParam(modelCode: $modelCode) {
          cfg
          samplerIndex
          # steps
        }
      }
    }
  }
`

export const GET_AI_MODELCODE_SIZES = gql`
  query getAIModelcodeSizes($modelCode: Int) {
    pictureGraph {
      aiCreateArtworkOptionMenu {
        ddSize: sizeSetOptions(model: DISCO_DIFFUSION, modelCode: $modelCode) {
          name
          desc
          url
          resolutionList {
            length
            width
            price
            superType
          }
        }
        sdSize: sizeSetOptions(model: STABLE_DIFFUSION, modelCode: $modelCode) {
          name
          desc
          url
          resolutionList {
            length
            width
            price
            superType
          }
        }
      }
    }
  }
`

/** 描述提示词选项 */
export const GET_AI_PROMPTS = gql`
  query getAIPrompt($model: AiCreateArtworkModel!, $num: Int = 2) {
    pictureGraph {
      aiCreateArtworkOptionMenu {
        promptTipsOptions(num: $num, model: $model) {
          name
        }
      }
    }
  }
`

/** 作画时间、可用作画次数等 */
export const GET_AI_TOTAL_INFO = gql`
  query getAITotalInfo($model: AiCreateArtworkModel = ANIME_DIFFUSION) {
    pictureGraph {
      aiArtworkTotalInfo {
        expectedSeconds: expectedSeconds(model: $model) {
          queueNum
          freeExpectedSeconds
          proExpectedSeconds
          reduceTime
        }
        userIntegral
        buyTimes: useNum(type: DESERVED)
        freeTimes: useNum(type: DAILY_FREE)
      }
    }
  }
`

/** 单一模型的作画时长 */
export const GET_EXPECTED_SECONDS = gql`
  query getExpectedSeconds($modelCode: Int!) {
    pictureGraph {
      aiArtworkTotalInfo {
        expectedSeconds: expectedSecondsByModelCode(modelCode: $modelCode) {
          queueNum
          freeExpectedSeconds
          proExpectedSeconds
          reduceTime
        }
      }
    }
  }
`

/** 生成作画 */
export const AI_CREATE_ARTWORK = gql`
  mutation aiCreateArtwork($param: AiCreateArtworkParam!) {
    pictureMutation {
      id: aiCreateArtwork(param: $param)
    }
  }
`

/** 作画预处理 */
export const AI_PRE_CREATE = gql`
  query aiPreCreate($param: AiCreateArtworkParam!) {
    pictureGraph {
      aiArtworkPayStrategyTips(param: $param) {
        integralUse {
          integralUseOnAccelerate
          integralUseOnCreate
          integralUseOnResolution
        }
        userRightsUse {
          dailyFreeCreateTimesUse
          deservedCreateTimesUse
        }
        vipRightsUse {
          accelerateTimesUse
          createTimesUse
        }
      }
    }
  }
`

export const BUY_AI_TIMES = gql`
  mutation buyAITimes($times: Int!) {
    pictureMutation {
      status: buyAiCreatePictureTimes(times: $times)
    }
  }
`

export const GET_AI_ARTWORK_PAGE = gql`
  query getAIArtWorkPage(
    $first: Int
    $offset: Int
    $param: AiArtworkQueryInput
    # 精简广场/投稿选图的字段
    $simplify: Boolean = false
    $plaza: Boolean = false
  ) {
    pictureGraph {
      aiArtworkPage(page: { first: $first, offset: $offset }, param: $param) {
        edges {
          node {
            artWorkUrl @skip(if: $simplify)
            miniArtWorkUrl
            completeTime @skip(if: $simplify)
            completePercent @skip(if: $simplify)
            expectedSeconds @skip(if: $simplify)
            generateTime @skip(if: $simplify)
            id
            status
            width: length
            height: width
            involveYellow
            extend {
              # 是否上架到市场 已上架
              artworkLink
              # 是否参加大赛 已投稿
              competitionLink
              # 是否发布到广场 已发布
              squarePostLink
            }
            riskControl {
              status
              reason
            }
            chatGptOptimize
            maskImageUrl
            # 广场发布需要的字段
            keyOfInitParam @include(if: $plaza)
            prompt @include(if: $plaza)
            ucPrompt @include(if: $plaza)
            model @include(if: $plaza)
            modelTheme @include(if: $plaza)
            styleDecorationOptions @include(if: $plaza) {
              key
              name
            }
            characterOptions @include(if: $plaza) {
              key
              name
            }
            modelFusionOptions: modelFusion @include(if: $plaza) {
              key
              name
              weight
            }
            size @include(if: $plaza)
            initImageUrl @include(if: $plaza)
            pattern @include(if: $plaza)
            # 预处理方式
            pretreatmentMethod @include(if: $plaza)
            # 预处理图
            pretreatmentImage @include(if: $plaza) {
              url
            }
            creativityDegree @include(if: $plaza)
            superType @include(if: $plaza)
            prefineInfo @include(if: $plaza) {
              strength
              multiple
            }
            seed @include(if: $plaza)
            cfg @include(if: $plaza)
            samplerModelInfo @include(if: $plaza) {
              samplerModelName
              samplerIndex
              # steps
            }
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`

export const GET_AI_ARTWORK = gql`
  query getAIArtWork($id: Long!, $collectionId: Long) {
    pictureGraph {
      aiArtwork(id: $id, aiCollectionId: $collectionId) {
        id
        beforeAfterId {
          beforeId
          afterId
        }
        # ai大赛作品
        artwork {
          id
          status
        }
        modelTheme
        styleDecorationOptions {
          key
          name
          type
        }
        characterOptions {
          key
          name
          type
        }
        modelFusionOptions: modelFusion {
          key
          name
          weight
        }
        artWorkUrl
        miniArtWorkUrl
        completeTime
        expectedSeconds
        completePercent
        generateTime
        status
        initImageUrl
        creativityDegree
        prompt
        promptOptimize
        size
        userName
        model
        specificSize
        width
        length
        involveYellow
        technologyInfo {
          electricity
          gpuType
          serverId
        }
        superSizePicInfo {
          artWorkUrl
          integral
          length
          multiple: multipleNew
          status
          width
        }
        riskControl {
          status
          reason
        }
        extend {
          similarAiArtworkPost {
            id
          }
          squarePostLink
          originalSquarePost {
            id
            status
          }
        }
        maskImageUrl
        maskZoneImageUrl
        modelCode
        ucPrompt
        pattern
        doRepairTheHand # 是否是修手后的图
        supportRepairTheHand # 生成该图的模型是否支持修手
        createSource # 创建来源 0-正常绘画 1-一键照改漫
        # 预处理图
        pretreatmentImage {
          url
        }
        prefineInfo {
          strength
          multiple
        }
        seed
        cfg
        # 预处理方式
        pretreatmentMethod
        superType
        samplerModelInfo {
          samplerModelName
          samplerIndex
          # steps
        }
        supportPrefine # 生成该图的模型是否支持精绘
      }
    }
  }
`

export const POLL_AI_ARTWORK = gql`
  query pollAIArtWork($id: Long!) {
    pictureGraph {
      aiArtworkGeneratingInfo(id: $id) {
        id
        artWorkUrl
        miniArtWorkUrl: miniArtworkUrl
        expectedSeconds
        status
        completeTime
        completePercent
        nextPollingTime
        queueBeforeNum
        reduceTime
        involveYellow
      }
    }
  }
`

export const POLL_AI_ARTWORKS = gql`
  query pollAIArtWorks($ids: [Long]!) {
    pictureGraph {
      aiArtworksGeneratingInfo(ids: $ids) {
        list {
          id
          artWorkUrl
          expectedSeconds
          status
          completeTime
          completePercent
          nextPollingTime
          queueBeforeNum
          reduceTime
          miniArtWorkUrl
          involveYellow
          specificSize
          superSizePicInfo {
            artWorkUrl
            integral
            length
            multiple: multipleNew
            status
            width
          }
          # 预处理图
          pretreatmentImage {
            url
          }
          # 预处理方式
          pretreatmentMethod
        }
        nextPollingTime
      }
    }
  }
`

export const POLL_SUPER_AI_ARTWORK = gql`
  query pollSuperAiArtwork($id: Long!) {
    pictureGraph {
      aiArtwork(id: $id) {
        id
        superSizePicInfo {
          artWorkUrl
          integral
          length
          multiple: multipleNew
          status
          width
        }
      }
    }
  }
`

export const DELETE_AI_ARTWORK = gql`
  mutation deleteAiArtwork($ids: [ID!]!) {
    pictureMutation {
      nums: deleteAiArtwork(ids: $ids)
    }
  }
`

export const SUPER_SIZE_AI_ARTWORK = gql`
  mutation superSizeAiArtwork(
    $id: Long!
    $multiple: Int!
    $multipleNew: Float
    $payStrategy: AiArtworkPayStrategyInput
  ) {
    pictureMutation {
      status: superSizeAiArtwork(
        aiArtWorkId: $id
        multiple: $multiple
        multipleNew: $multipleNew
        payStrategy: $payStrategy
      )
    }
  }
`

export const SPEED_ACCELERATE_AI_ARTWORK = gql`
  mutation aiCreateArtworkAccelerate($param: AiCreateArtworkAccelerate!) {
    pictureMutation {
      status: aiCreateArtworkAccelerate(param: $param)
    }
  }
`
export const CANCEL_CREATE_AI_ARTWORK = gql`
  mutation cancelAiCreateArtwork($id: Long!) {
    pictureMutation {
      status: cancelAiCreateArtwork(id: $id)
    }
  }
`

export const GET_AI_ARTWORK_NEWEST_36 = gql`
  query getAIArtWorkNewst36(
    $first: Int
    $offset: Int
    $param: AiArtworkQueryInput
  ) {
    pictureGraph {
      aiArtworkPage(page: { first: $first, offset: $offset }, param: $param) {
        edges {
          node {
            id
            artWorkUrl
            miniArtWorkUrl
            completePercent
            completeTime
            expectedSeconds
            generateTime
            status
            initImageUrl
            creativityDegree
            prompt
            promptOptimize
            size
            style
            userName
            model
            specificSize
            involveYellow
            modelTheme
            chatGptOptimize
            styleDecorationOptions {
              key
              name
              type
            }
            characterOptions {
              key
              name
              type
            }
            modelFusionOptions: modelFusion {
              key
              name
              weight
            }
            superSizePicInfo {
              artWorkUrl
              integral
              length
              multiple: multipleNew
              status
              width
            }
            # ai大赛作品
            artwork {
              id
              status
            }
            width
            length
            maskImageUrl
            maskZoneImageUrl
            riskControl {
              status
            }
            modelCode
            extend {
              squarePostLink
              similarAiArtworkPost {
                id
              }
            }
            ucPrompt
            doRepairTheHand # 是否开启修手
            createSource # 创建来源 0-正常绘画 1-一键照改漫
            # 预处理图
            pretreatmentImage {
              url
            }
            seed
            cfg
            # 预处理方式
            pretreatmentMethod
            samplerModelInfo {
              samplerModelName
              samplerIndex
              # steps
            }
            superType
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`
/** 申诉理由 */
export const APPEAL_AI_ARTWORK = gql`
  mutation appealAiArtWork($param: AiArtworkAppealInput!) {
    pictureMutation {
      status: appealAiArtwork(input: $param)
    }
  }
`

/** 分享下载原图链接 */
export const SHARE_ARTWORK_URL = gql`
  query shareArtworkUrl($id: Long!) {
    pictureGraph {
      url: getAiArtworkUrlByInvitationCode(aiArtworkId: $id)
    }
  }
`

/** 分享作品详情 */
export const SHARE_ARTWORK_DETAIL = gql`
  query shareArtWorkDetail($id: Long!) {
    pictureGraph {
      aiArtwork: aiArtworkShare(id: $id) {
        id
        miniArtWorkUrl
        involveYellow
        riskControl {
          status
        }
        width: length
        height: width
      }
    }
  }
`

/** 分享作者信息 */
export const ARTWORK_USERINFO = gql`
  query getArtworkUserInfo($uid: Long) {
    userinfo: copyrightUserInfo(uid: $uid) {
      avatarUrl
      nickname
      userRoleInfo {
        artist
        aiArtist
      }
    }
  }
`

/** 修手 */
export const FIX_HAND = gql`
  mutation fixHand($id: Long!) {
    pictureMutation {
      id: aiCreateArtworkRepairTheHand(aiArtworkId: $id)
    }
  }
`
/** 查询一键同款 */
export const AI_ARTWORK_SQUARE_SAME = gql`
  query AiArtworkSquareSame($id: Long) {
    squareModule {
      status: aiArtworkSquareSameStatus(aiArtworkId: $id)
    }
  }
`

/** 一键精绘 */
export const PREFINE = gql`
  mutation prefine($id: Long!) {
    pictureMutation {
      id: aiCreateArtworkPrefine(aiArtworkId: $id)
    }
  }
`

/** controlnet根据图片精绘options */
export const GET_CONTROLNET_PREFINE_OPTIONS = gql`
  query getControlnetPrefineOptions($width: Int, $height: Int) {
    pictureGraph {
      aiCreateArtworkOptionMenu {
        controlPrefineOption(width: $width, height: $height) {
          superType
          price
        }
      }
    }
  }
`

export const ChatGPT_Result = gql`
  query chatGptResult($taskId: String!) {
    chatGPTQuery {
      gptResult: asyncOptPromptResult(taskId: $taskId) {
        result
        status
        taskId
      }
    }
  }
`

/** 使用chatgpt生成描述 */
export const ChatGPT_Make = gql`
  mutation chatGptMake(
    $model: AiCreateArtworkModel
    $text: String
    $taskId: String!
    $language: Language
    $modelCode: Int
  ) {
    chatGPTMutation {
      content: asyncOptPrompt(
        model: $model
        original: $text
        taskId: $taskId
        language: $language
        modelCode: $modelCode
      ) {
        taskId
        timeSeconds
      }
    }
  }
`
